@import 'styles/mixins';
@import 'styles/variables';

.reactions {
  display: flex;
  gap: 6px 4px;
  margin-top: 6px;
  margin-left: calc(var(--collab-item-avatar-size) + var(--collab-item-avatar-gap));
  flex-wrap: wrap;
}

.addReaction {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  width: 28px;
  @include transition(0.2s);

  &:hover {
    background: $grey-5;
  }

  svg {
    height: 16px;
    width: 16px;
    fill: $grey-40;
  }
}

.popoverOverride {
  padding: 0;
}
